import React, { useEffect, Fragment, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Alert, Table, Tooltip } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import ReportActions from '@Actions/reportActions';
import Helpers from '@Apis/helpers';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import { QUANTITY, toISTDate } from '@Apis/constants';
import ProductionReportHeader from '../ProductionReportHeader';

/**
 *
 */
function ProductionReportTable({
  getProductionReportsLoading, getProductionReports, user, productionReportData,
  history, MONEY,

}) {
  const getColumns = () => {
    const moColumnsFG = [
      {
        title: 'ORDER NUMBER',
        fixed: 'left',
        render: (record) => (
          // <Link target="_BLANK" to={`/production/manufacturing-orders/view/${record?.mo_id}`}>
          //   {' '}
          //   <H3Text text={record?.mo_number || '-'} />
          // </Link>
          <H3Text text={record?.mo_number || '-'} />
        )
        ,
      },
      {
        title: 'ORDER DATE',
        render: (record) => (
          <div>
            {toISTDate(record?.mo_date).format('DD/MM/YYYY')}
          </div>
        ),
      },
      {
        title: 'LOCATION ',
        render: (record) => (
          <div>
            <H3Text text={(record?.tenant_name ? `${record?.tenant_name}` : '')} />
            <H3Text text={(record?.department ? `${record?.department}` : '')} className="table-subscript" />
          </div>
        ),

      },
      {
        title: 'VENDOR ',
        render: (record) => (
          <div>
            <Link to={`/vendors/view/${record?.seller_id}`} target="_blank">
              <H3Text text={(record?.seller_name ? `${record?.seller_name}` : '')} />
            </Link>
          </div>
        ),

      },
      {
        title: 'STATUS ',
        key: 'action',
        render: (record) => (
          <div>
            <H3Text text={(record?.status ? `${record?.status?.split('_')?.join(' ')?.toProperCase()}` : '')} />
          </div>
        ),

      },
      {
        title: 'PROCUZY SKU#',
        render: (record) => (
          <Link target="_BLANK" to={`/inventory/product/view/${record?.product_sku_id}`}>
            {record?.internal_sku_code ? (
              <H3Text text={record?.internal_sku_code} />
            ) : '-'}
          </Link>
        ),
      },
      {
        title: 'INTERNAL SKU#',
        render: (record) => (
          <div>
            {record?.ref_product_code ? (
              <H3Text text={record?.ref_product_code} />
            ) : '-'}

          </div>
        ),
      },
      {
        title: 'PRODUCT NAME',
        render: (record) => (
          <React.Fragment>
            <H3Text text={record?.product_sku_name || ''} />
            <H3Text text={record?.hsn_code || ''} className="table-subscript" />
            {record?.product_category_info?.category_path && (
              <Tooltip
                overlay={(
                  <div
                    style={{
                      color: 'rgb(0, 0, 0)',
                      fontSize: '12px',
                      fontWeight: '500',
                      padding: '2px',
                    }}
                  >
                    {record.product_category_info.category_path.join(' / ')}
                  </div>
                )}
                color="rgb(234, 242, 254)"
              >
                {' '}
                {/* Tooltip wrapping the div */}
                <div
                  className="category__status_tag"
                  style={{ backgroundColor: '#3aa5a6' }}
                >
                  {/* Displaying only the last category name with ellipsis if path is long */}
                  {record?.product_category_info ? (
                    `.../${record?.product_category_info?.product_category_name}`
                  ) : (
                    ''
                  )}
                </div>
              </Tooltip>
            )}

          </React.Fragment>
        ),

      },
      {
        title: 'TARGET PRODUCTION',
        render: (record) => (
          <div>
            <H3Text text={record?.target_production ? `${QUANTITY(record?.target_production)} ${record?.uqc?.toProperCase()}` : '-'} />
          </div>
        ),
      },
      {
        title: 'COMPLETED PRODUCTION',
        render: (record) => (
          <div>
            <H3Text text={'completed_production' in record ? `${QUANTITY(record?.completed_production)} ${record?.uqc?.toProperCase()}` : '-'} />
          </div>
        ),
      },
      {
        title: 'SCRAP',
        render: (record) => (
          <div>
            <H3Text text={'scrap' in record ? `${QUANTITY(record?.scrap)} ${record?.uqc?.toProperCase()}` : '-'} />
          </div>
        ),
      },

      {
        title: 'BATCH NUMBER',
        render: (record) => (record?.batch_number ? record?.batch_number : '-'),
      },
      {
        title: 'REJECTED BATCH NUMBER',
        render: (record) => (record.rejected_batch_number ? record?.rejected_batch_number : '-'),
      },
      {
        title: 'LOT NUMBER',
        render: (record) => (record?.lot_number ? record?.lot_number : '-'),
      },
      {
        title: 'EXPIRY DATE',
        render: (record) => (
          <div>
            {record?.expiry_date ? toISTDate(record?.expiry_date).format('DD/MM/YYYY') : '-'}
          </div>
        ),
      },
      {
        title: 'COMPLETION DATE',
        render: (record) => (
          <div>
            {record?.completion_date ? toISTDate(record?.completion_date).format('DD/MM/YYYY') : '-'}
          </div>
        ),
      },
      {
        title: 'ESTIMATED UNIT COST',
        render: (record) => (record?.estimated_unit_cost ? MONEY(record?.estimated_unit_cost) : '-'),
      },
      {
        title: 'ESTIMATED BATCH COST',
        render: (record) => (record?.estimate_batch_cost ? MONEY(record?.estimate_batch_cost) : '-'),
      },
      {
        title: 'QC COMPLETION DATE',
        render: (record) => (
          <div>
            {record?.qc_completion_date ? toISTDate(record?.qc_completion_date).format('DD/MM/YYYY') : '-'}
          </div>
        ),
      },

    ];
    const moColumnsRM = [
      {
        title: 'ORDER NUMBER',
        fixed: 'left',
        render: (record) => (
          <Link target="_BLANK" to={`/production/manufacturing-orders/view/${record?.mo_id}`}>
            {' '}
            <H3Text text={record?.mo_number || '-'} />
          </Link>
        )
        ,
      },
      {
        title: 'ORDER DATE',
        render: (record) => (
          <div>
            {toISTDate(record?.mo_date).format('DD/MM/YYYY')}
          </div>
        ),
      },
      {
        title: 'LOCATION ',
        render: (record) => (
          <div>
            <H3Text text={(record?.tenant_name ? `${record?.tenant_name}` : '')} />
            <H3Text text={(record?.department ? `${record?.department}` : '')} className="table-subscript" />
          </div>
        ),

      },
      {
        title: 'VENDOR ',
        render: (record) => (
          <div>
            <Link to={`/vendors/view/${record?.seller_id}`} target="_blank">
              <H3Text text={(record?.seller_name ? `${record?.seller_name}` : '')} />
            </Link>
          </div>
        ),

      },
      {
        title: 'STATUS ',
        key: 'action',
        render: (record) => (
          <div>
            <H3Text text={(record?.status ? `${record?.status?.split('_')?.join(' ')?.toProperCase()}` : '')} />
          </div>
        ),

      },
      {
        title: 'PROCUZY REF ID',
        render: (record) => (
          <div>
            {record?.internal_sku_code ? (
              <H3Text text={record?.internal_sku_code} />
            ) : '-'}

          </div>
        ),
      },
      {
        title: 'INTERNAL REFERENCE ID',
        render: (record) => (
          <div>
            {record?.ref_product_code ? (
              <H3Text text={record?.ref_product_code} />
            ) : '-'}

          </div>
        ),
      },
      {
        title: 'PRODUCT NAME',
        render: (record) => (
          <React.Fragment>
            <H3Text text={record?.product_sku_name || ''} />
            <H3Text text={record?.hsn_code || ''} className="table-subscript" />
            {(record?.product_category_info?.category_path) && (
              <div className="category__status_tag" style={{ backgroundColor: '#3aa5a6' }}>
                {record.product_category_info.category_path.join(' / ')}
              </div>
            )}

          </React.Fragment>
        ),

      },
      {
        title: 'CONSUMPTION',
        render: (record) => (
          <div>
            <H3Text text={record?.quantity ? `${QUANTITY(record?.quantity)} ${record?.uqc?.toProperCase()}` : '-'} />
          </div>
        ),
      },
      {
        title: 'CONSUMED',
        render: (record) => (
          <div>
            <H3Text text={record?.adjustment_quantity ? `${QUANTITY(record?.adjustment_quantity)} ${record?.uqc?.toProperCase()}` : '-'} />
          </div>
        ),
      },
      {
        title: 'WASTAGE',
        render: (record) => (
          <div>
            <H3Text text={record?.wastage_quantity ? `${QUANTITY(Math.abs(record?.wastage_quantity))} ${record?.uqc?.toProperCase()}` : '-'} />
          </div>
        ),
      },
      {
        title: 'FG BATCH NUMBER',
        render: (record) => (record?.fg_batch_number || '-'),
      },
      {
        title: 'BATCH NUMBER',
        render: (record) => (record?.batch_number ? record?.batch_number : '-'),
      },
      {
        title: 'LOT NUMBER',
        render: (record) => (record?.lot_number ? record?.lot_number : '-'),
      },
      {
        title: 'EXPIRY DATE',
        render: (record) => (
          <div>
            {record?.expiry_date ? toISTDate(record?.expiry_date).format('DD/MM/YYYY') : '-'}
          </div>
        ),
      },
      {
        title: 'CONSUMPTION DATE',
        render: (record) => (
          <div>
            {record?.consumption_date ? toISTDate(record?.consumption_date).format('DD/MM/YYYY') : '-'}
          </div>
        ),
      },
      {
        title: 'COST PRICE',
        render: (record) => (record?.cost_price ? MONEY(record?.cost_price) : '-'),
      },
      {
        title: 'TOTAL COST',
        render: (record) => (record?.total_cost ? MONEY(record?.total_cost) : '-'),
      },

    ];
    if (selectedMoType === 'FINISHED_GOODS') {
      return moColumnsFG;
    }
    return moColumnsRM;
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [department, setDepartment] = useState('');
  const [selectedMoType, setSelectedMoType] = useState('');
  const [selectedCategory, setSelectedCategory] = useState([]);

  /**
   *
   * @param {*} keyword
   * @param {*} status
   * @param {*} stockType
   * @param {*} productCategory
   * @param {*} page
   * @param {*} limit
   */
  const pushParamsToUrl = (startDateMomentEpoch, endDateMomentEpoch, tenant, selectedDepartment, moType, status, page, currentLimit, category) => {
    let url = '';
    if (startDateMomentEpoch) url += `?startDate=${startDateMomentEpoch}`;
    if (endDateMomentEpoch) url += `&endDate=${endDateMomentEpoch}`;
    if (tenant) url += `&tenant=${tenant}`;
    if (selectedDepartment) url += `&department_id=${selectedDepartment}`;
    if (moType) url += `&mo_type=${moType}`;
    if (status) url += `&status=${status}`;
    if (page) url += `&page=${page}`;
    if (currentLimit) url += `&limit=${currentLimit}`;
    if (category) url += `&category=${category}`;
    history.push(url);
  };

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      setLimit(Helpers.getValueFromUrl('limit') || limit);
      setSelectedStatus(Helpers.getValueFromUrl('status'));
      setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (Number(item))) : [user?.tenant_info?.tenant_id]);
      setStartDate(Number(Helpers.getValueFromUrl('startDate')) || dayjs().utc().startOf('month').valueOf());
      setEndDate(Number(Helpers.getValueFromUrl('endDate')) || dayjs().utc().endOf('month').valueOf());
      setDepartment(Helpers.getValueFromUrl('department_id') ? Number(Helpers.getValueFromUrl('department_id')) : '');
      setSelectedMoType(Helpers.getValueFromUrl('mo_type') || 'FINISHED_GOODS');
      setSelectedCategory(Helpers.getValueFromUrl('category')?.split(',')?.filter(Boolean)?.map(Number) || []);
      setIsUserReady(true);
    }
  }, []);

  useEffect(() => {
    if (isUserReady) {
      // tenantIds, fromDate, toDate, page, limit, departmentId, moType, status
      // startDateMomentEpoch, endDateMomentEpoch, tenant, selectedDepartment, moType, status, page, currentLimit
      pushParamsToUrl(startDate, endDate, selectedTenant, department, selectedMoType, selectedStatus, currentPage, limit, selectedCategory);
      getProductionReports(
        selectedTenant?.filter(
          (item) => !isNaN(item),
        )?.length > 0
          ? selectedTenant?.join(',')
          : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ)?.join(','),
        Helpers.getValueFromUrl('startDate'), Helpers.getValueFromUrl('endDate'), Helpers.getValueFromUrl('page'),
        50, Helpers.getValueFromUrl('department_id'), Helpers.getValueFromUrl('mo_type'), Helpers.getValueFromUrl('status'),
        Helpers.getValueFromUrl('category'),
      );
    }
  }, [startDate, endDate, currentPage, selectedTenant, department, selectedMoType, selectedStatus, currentPage, limit, selectedCategory]);

  /**
   *
   * @param {*} data
   * @return
   */
  const getDataSource = () => {
    const tempData = [];
    // Use slice(0, 50) to get the first 50 items from the array
    const operationData = productionReportData?.production?.slice(0, 50) || [];
    for (let i = 0; i < operationData.length; i++) {
      tempData.push({
        ...operationData[i],
        key: uuidv4(),
      });
    }
    return tempData;
  };

  return (
    <Fragment>
      <div className="view-production__report__wrapper">
        <ProductionReportHeader
          startDate={startDate}
          endDate={endDate}
          selectedTenant={selectedTenant}
          department={department}
          selectedMoType={selectedMoType}
          selectedStatus={selectedStatus}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          setSelectedTenant={setSelectedTenant}
          setDepartment={setDepartment}
          setSelectedMoType={setSelectedMoType}
          setSelectedStatus={setSelectedStatus}
          setCurrentPage={setCurrentPage}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}

        />
        <div className="generic-table-container reports-table-container">

          <Table
            loading={getProductionReportsLoading}
            bordered
            showHeader
            size="small"
            scroll={{ x: 'max-content' }}
            columns={getColumns()}
            dataSource={getDataSource()}
            pagination={{
              // total: Number(productionReportData?.count),
              pageSize: 50,
              // position: ['bottomLeft'],
              // showSizeChanger: false,
              // onChange: (page, pageSize) => {
              //   setCurrentPage(page);
              //   setLimit(pageSize);
              // },
              showTotal: () => (
                <div className="reports-table__footer">
                  <H3Text text={`Showing ${((currentPage - 1) * 50) + 1} - ${getDataSource()?.length + ((currentPage - 1) * 50)} Records`} className="reports-table__footer-text" />
                  <Alert
                    showIcon
                    type="info"
                    message="You can only view 50 records at a time. Please download the report to view all records"
                  />
                </div>
              ),
            }}
          />

        </div>
      </div>

    </Fragment>
  );
}

const mapStateToProps = ({ ReportReducers, UserReducers }) => ({
  getProductionReportsLoading: ReportReducers.getProductionReportsLoading,
  productionReportData: ReportReducers.productionReportData,
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});
const mapDispatchToProps = (dispatch) => ({
  getProductionReports: (tenantIds, fromDate, toDate, page, limit, departmentId, moType, status, category) => dispatch(
    ReportActions.getProductionReports(tenantIds, fromDate, toDate, page, limit, departmentId, moType, status, category),
  ),
});

ProductionReportTable.propTypes = {
  history: PropTypes.func,
  getProductionReports: PropTypes.func,
  user: PropTypes.any,
  getProductionReportsLoading: PropTypes.bool,
  productionReportData: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductionReportTable));
